import { Link } from "gatsby";
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Blocks from "editorjs-blocks-react-renderer";
import ImageRenderer from "../imageRenderer";

const NewsGroup = ({ data }) => {
  if (!data || !data.NewsTeaserGroup) {
    return <></>; // Return empty fragment if data is missing
  }

  return (
    <div className="max-w-screen-xl xxl:max-w-screen-3xl mx-auto my-10 lg:my-16 xl:p-0 p-5">
      <div className="my-10 text-left">
        <div className="text-teal text-2xl font-bold">
          {data.NewsTeaserTitle || ""}
        </div>
        <p className="text-lg">{data.NewsTeaserIntroText || ""}</p>
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-10">
        {data.NewsTeaserGroup.length > 0 &&
          data.NewsTeaserGroup.map((item, index) => {
            const teaser = item.news_teaser || {};
            const image =
              teaser.NewsTeaserImage?.localFile &&
              getImage(teaser.NewsTeaserImage.localFile);

            return (
              <div className="mt-4" key={index}>
                {image ? (
                  <GatsbyImage
                    image={image}
                    className="rounded-lg object-cover h-60 w-full"
                    alt="news image"
                  />
                ) : (
                  <div className="h-60 w-full bg-gray-200 rounded-lg"></div>
                )}

                <div className="mb-5 mt-4">
                  <h4 className="text-teal text-xl font-bold mb-4">
                    {teaser.NewsTeaserTitle || ""}
                  </h4>
                  {teaser.NewsTeaserSummary?.data?.NewsTeaserSummary ? (
                    <div className="mt-3 prose">
                      <Blocks
                        data={JSON.parse(
                          teaser.NewsTeaserSummary.data.NewsTeaserSummary
                        )}
                        renderers={{
                          image: ImageRenderer,
                        }}
                      />
                    </div>
                  ) : (
                    <span></span> // Empty span to prevent layout shift
                  )}
                  <div className="mt-3">
                    {teaser.news_article?.Slug ? (
                      <Link
                        to={`/news/${teaser.news_article.Slug}`}
                        className="text-orange underline font-medium text-base rounded-xl"
                      >
                        Explore
                      </Link>
                    ) : (
                      <span></span> // Empty span to avoid layout issues
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default NewsGroup;
